// extracted by mini-css-extract-plugin
module.exports = {"optIn":"_b30e00e","intro":"_2569978","button":"_25d46c1","logo":"_9c63f59","inverseLogo":"_171f40e","star":"_319d147","expanded":"_ed07341"};